import type { taskEither } from "fp-ts";

import type {
  GetCreationDateOfFirstOrder,
  GetOrderStatistics,
  GetRevenueForYear,
  SendEmail,
} from "./ios";

import type { AuthenticationError, UnexpectedError } from "~/shared/error";

abstract class Provider {
  abstract getOrderStatistics(): taskEither.TaskEither<
    UnexpectedError | AuthenticationError,
    GetOrderStatistics.Out
  >;
  abstract sendEmail(
    params: SendEmail.In,
  ): taskEither.TaskEither<UnexpectedError | AuthenticationError, void>;
  abstract getRevenueForYear(
    params: GetRevenueForYear.In,
  ): taskEither.TaskEither<UnexpectedError | AuthenticationError, GetRevenueForYear.Out>;
  abstract getCreationDateOfFirstOrder(): taskEither.TaskEither<
    UnexpectedError | AuthenticationError,
    GetCreationDateOfFirstOrder.Out
  >;
}

export { Provider };
